export const COMMON_ROUTES = {
	AUTH: 'auth',
	AUTO_CREATOR: 'auto-creator',
	REGISTER_COMPANY: 'register/company',
	REGISTER_COMPANY_STORY_URL_WITH_GOOGLE: 'register/company-story-url-with-google',
	REGISTER_COMPANY_WITH_GOOGLE: 'register/company-with-google',
	SIGN_IN_WITH_GOOGLE: 'sing-in/google',
	SET_PASSWORD_AFTER_REGISTRATION: 'set-password-after-registration',
	SET_PASSWORD_AFTER_FORGOT: 'set-password-after-forgot',
	CHECK_REGISTER_HASH: 'check-register-hash',
	CHECK_FORGOT_HASH: 'check-forgot-hash',
	FORGOT_PASSWORD: 'forgot/password',
	//
	CHECK_EMAIL_AVAILABILITY: 'check-email-availability',
	//
	LOGIN_TO_PLATFORM_FROM_SUPER_ADMIN_PANEL: 'login-to-platform-from-super-admin-panel',
	//
	TEAM: 'team',
	TEAM_MEMBER: 'members',
	NEW_MEMBER: 'new',
	TECHNOLOGY: 'technology',
	NEW_TECHNOLOGY: 'new',
	PRESET_TECHNOLOGY: 'preset',
	ALL_TECHNOLOGY: 'all',
	INVITATION: 'invitations',
	RESEND: 'resend',
	ACCEPT_INVITATION: 'accept-invitation',
	CHECK_INVITATION: 'check-invitation',
	USERS: 'users',
	COMMENT: 'comments',
	FEEDBACK_VALIDATION: 'feedback-validation',
	PLAN_UPGRADE_REQUESTS: 'plan-upgrade-requests',
	// story from url
	REGISTER_COMPANY_AFTER_STORY_URL: 'register/company/story-url',
	CHECK_IDENTIFIER: 'check-identifier',
} as const

// export const getAutoCreatorDashboardUrl = (): string => {
// 	return `/${COMMON_ROUTES.AUTO_CREATOR}/db/dashboard`
// }

// export const getAutoCreatorBatchUrlPost = (): string => {
// 	return `/${COMMON_ROUTES.AUTO_CREATOR}/batch`
// }

// export const getAutoCreatorPatchStoryUrlPatch = (): string => {
// 	return `/${COMMON_ROUTES.AUTO_CREATOR}/patch-story-url`
// }

export const getAuthRegisterCompanyUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.REGISTER_COMPANY}`
}
export const getAuthSignInWithGoogleUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.SIGN_IN_WITH_GOOGLE}`
}
export const getAuthRegisterCompanyStoryUrlWithGoogleUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.REGISTER_COMPANY_STORY_URL_WITH_GOOGLE}`
}
export const getAuthRegisterCompanyWithGoogleUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.REGISTER_COMPANY_WITH_GOOGLE}`
}
export const getAuthRegisterCompanyAfterStoryUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.REGISTER_COMPANY_AFTER_STORY_URL}`
}
export const getAuthCheckRegistrationHashUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.CHECK_REGISTER_HASH}`
}
export const getAuthCheckResetHashUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.CHECK_FORGOT_HASH}`
}
export const getAuthCheckEmailAvailabilityUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.CHECK_EMAIL_AVAILABILITY}`
}
// TODO create story from url Это должен быть отдельный маршрут в отедльный сервис, который будет принимать идентификатор и проверять его в базе данных
export const getAuthCheckIdentifierUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.CHECK_IDENTIFIER}`
}
export const getAuthSetPasswordAfterRegistrationUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.SET_PASSWORD_AFTER_REGISTRATION}`
}
export const getAuthForgotPasswordUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.FORGOT_PASSWORD}`
}
export const getAuthSetPasswordAfterForgotUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.SET_PASSWORD_AFTER_FORGOT}`
}
export const getAuthLoginToPlatformFromSuperAdminPanelUrlPost = (): string => {
	return `/${COMMON_ROUTES.AUTH}/${COMMON_ROUTES.LOGIN_TO_PLATFORM_FROM_SUPER_ADMIN_PANEL}`
}

//
export const getTeamMainUrl = (): string => {
	return `/${COMMON_ROUTES.TEAM}`
}
export const getTeamMainUrlPost = (): string => {
	return `/${COMMON_ROUTES.TEAM}`
}
export const getTeamMemberUpdateUrlPost = (teamMemberId: string): string => {
	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}/${teamMemberId}`
}
export const getTeamMemberCreateNewUrlPost = (): string => {
	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}/${COMMON_ROUTES.NEW_MEMBER}`
}
export const getTeamMemberDeleteUrl = getTeamMemberUpdateUrlPost
export const getAllTeamMembers = (): string => {
	return `/${COMMON_ROUTES.TEAM}/${COMMON_ROUTES.TEAM_MEMBER}`
}

export const getTechnologyUpdateUrlPost = (technologyId: string): string => {
	return `/${COMMON_ROUTES.TECHNOLOGY}/${technologyId}`
}
export const getTechnologyDeleteUrl = getTechnologyUpdateUrlPost
export const getAllTechnologies = (): string => {
	return `/${COMMON_ROUTES.TECHNOLOGY}`
}
export const getAllPresetTechnologies = (): string => {
	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.PRESET_TECHNOLOGY}`
}
export const getAllCompanyAndPresetTechnologies = (): string => {
	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.ALL_TECHNOLOGY}`
}
// comments
export const getCommentCreateUrlPost = (): string => {
	return `/${COMMON_ROUTES.COMMENT}`
}
export const getCommentsByStoryAndStep = (storyId: string, step: string): string => {
	return `/${COMMON_ROUTES.COMMENT}/${storyId}/${step}`
}
export const getCommentDeleteUrl = (commentId: string): string => {
	return `/${COMMON_ROUTES.COMMENT}/${commentId}`
}
export const getCommentUpdateUrlPatch = (commentId: string): string => {
	return `/${COMMON_ROUTES.COMMENT}/${commentId}`
}

export const getFeedbackValidationUrl = (token: string): string => {
	return `/${COMMON_ROUTES.FEEDBACK_VALIDATION}/${token}`
}

// plan upgrade requests (company/user side)
export const getPlanUpgradeRequestsUrl = (): string => {
	return `/${COMMON_ROUTES.PLAN_UPGRADE_REQUESTS}`
}

// admin - invitation
export const getAllInvitations = (): string => {
	return `/${COMMON_ROUTES.INVITATION}`
}
export const getInvitationUrlPost = (): string => {
	return `/${COMMON_ROUTES.INVITATION}`
}
export const getInvitationAcceptUrlPost = (): string => {
	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.ACCEPT_INVITATION}`
}
export const getInvitationCheckUrlPost = (): string => {
	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.CHECK_INVITATION}`
}
export const getInvitationDeleteUrl = (): string => {
	return `/${COMMON_ROUTES.INVITATION}`
}
export const getInvitationResendUrlPost = (): string => {
	return `/${COMMON_ROUTES.INVITATION}/${COMMON_ROUTES.RESEND}`
}

// admin - users
export const getAllUsers = (): string => {
	return `/${COMMON_ROUTES.USERS}`
}

export const getUserUpdateRoleUrlPatch = (userId: string, roleId: string | number): string => {
	return `/${COMMON_ROUTES.USERS}/${userId}/${roleId}`
}
export const getUserDeleteUrl = (userId: string): string => {
	return `/${COMMON_ROUTES.USERS}/${userId}`
}

// export const getAllStoryTechnologies = (storyId: string): string => {
// 	return `/${COMMON_ROUTES.TECHNOLOGY}/${COMMON_ROUTES.ALL_TECHNOLOGY}`
// }
// export const getAllStories = (): string => {
// 	return `/${STORY_ROUTES.BASE}/${STORY_ROUTES.ALL_STORIES}`
// }

// export const getStoryProjectUrlPost = (storyId: string): string => {
// 	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.PROJECT}`
// }
// export const getStoryClientUrlPost = (storyId: string): string => {
// 	return `/${STORY_ROUTES.BASE}/${storyId}/${STORY_ROUTES.CLIENT}`
// }
